import React from 'react';
import { Link } from "react-router-dom";
import './index.scss';

export default function Button(props) {
    return (
        <Link
            to={props.path}
            className={`${props.active} theme-button button p-2 rounded text-center mx-1`}
            style={{ textDecoration: 'none' }}
            onClick={props.action}
        >
            {props.icon && (
                <span className="position-relative ml-1 mr-2">
                    <i className={props.icon}></i>
                </span>
            )}
            <span style={{ whiteSpace: "nowrap" }}>
                {props.title}
            </span>
        </Link>
    );
}
